import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";

const MachineCardLoading = () => {
  return (
    <Card elevation={2} sx={{ flexGrow: 1, margin: 1 }}>
      <Skeleton variant="rectangular" sx={{ height: 160 }} animation="wave" />

      <CardHeader
        title={
          <Stack direction="row" alignItems="baseline">
            <Typography variant="h5">
              <Skeleton sx={{ width: 160 }} animation="wave" />
            </Typography>
            <Typography marginLeft={1}>
              <Skeleton sx={{ width: 60 }} animation="wave" />
            </Typography>
          </Stack>
        }
        subheader={
          <Typography color="gray" variant="body2">
            <Skeleton sx={{ width: 80 }} animation="wave" />
          </Typography>
        }
        sx={{ flexGrow: 1, paddingY: 1.5 }}
      />

      <CardContent sx={{ paddingY: 0 }}>
        {Array(2)
          .fill("")
          .map((item, index) => (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              key={index}
              sx={{ margin: 0, padding: 0 }}
            >
              <Stack direction="row" sx={{ margin: 0 }}>
                <Typography>
                  <Skeleton sx={{ width: 120 }} animation="wave" />
                </Typography>
                <Typography marginLeft={1} color="blue">
                  <Skeleton sx={{ width: 25 }} animation="wave" />
                </Typography>
              </Stack>
              <Button variant="text">
                <Skeleton sx={{ width: 50 }} animation="wave" />
              </Button>
            </Stack>
          ))}

        <Typography
          color="gray"
          sx={{
            flexGrow: 1,
            textAlign: "center",
          }}
        >
          <Skeleton animation="wave" />
        </Typography>
        <Stack direction="row" alignItems="center" flexGrow={1} marginTop={1}>
          <Skeleton animation="wave" sx={{ width: 60, height: 30 }} />
          <Skeleton
            animation="wave"
            sx={{ width: 60, height: 30, marginLeft: 1 }}
          />
          <Skeleton
            animation="wave"
            sx={{ width: 60, height: 30, marginLeft: 1 }}
          />
        </Stack>
      </CardContent>
      <CardActions sx={{ display: "flex", justifyContent: "center" }}>
        <Button color="primary">
          <Skeleton sx={{ width: 60 }} animation="wave" />
        </Button>
      </CardActions>
    </Card>
  );
};

export default MachineCardLoading;
